<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<div *ngrxLet="threats$ as threats"
     [ngClass]="{'optimal': threats?.threatsDetected === 0, 'pay-attention': threats?.threatsDetected > 0}"
     class="threats-detected-wrapper stats-component">
  <app-display-total-value
    title="{{'threats-detected.title' | translate}}"
    [total]="threats?.threatsDetected"
    [routeLink]="threatsLink"
    [routeQueryParams]="threatsQueryParams"
    [loading]="loadingThreats$ | async">
  </app-display-total-value>

  <app-display-relative-changes
    [loading]="loadingThreats$ | async"
    [amountChanged]="threats?.amountChanged"
    [relativeChange]="threats?.relativeChange">
  </app-display-relative-changes>
</div>
